module.exports = __webpack_public_path__ + "static/media/c54.fcc1050b.png";